import { Banner, Field, Input, Select } from '@cloudflare/kumo';
import { useMemo } from 'react';

// eslint-disable-next-line react-refresh/only-export-components
export const CAPI_EVENT_LABELS: Record<string, string> = {
  LeadSubmitted: 'Lead', QualifiedLead: 'Lead qualificado', Purchase: 'Compra', InitiateCheckout: 'Início de compra',
  AddToCart: 'Adicionou ao carrinho', ViewContent: 'Viu conteúdo', OrderCreated: 'Pedido criado',
};

/** Configuração do bloco "Conversão Meta Ads" */
export function MetaConversionConfig({ config, setConfig }: { config: any; setConfig: (c: any) => void }) {
  const options = useMemo(
    () => Object.entries(CAPI_EVENT_LABELS).map(([value, label]) => ({ value, label })),
    []
  );
  const eventName = config.eventName || 'LeadSubmitted';
  const selectedOption = options.find((o) => o.value === eventName) ?? null;
  return (
    <div className="space-y-3">
      <div className="text-kumo-subtle" style={{ color: 'var(--text-muted)' }}>
        Quando o contato passa por aqui, o Meta Ads recebe a conversão (Conversions API) e otimiza o anúncio "clique para WhatsApp".
        Só conta para quem chegou por anúncio; o mesmo evento vale uma vez por dia por contato.
      </div>
      <Field label="Evento">
        <Select value={(selectedOption)?.value ?? null} items={options} onValueChange={(value: string | null) => setConfig({ ...config, eventName: value ?? 'LeadSubmitted' })} />
      </Field>
      <Field label="Valor em R$ (opcional)">
        <Input onChange={(e) => setConfig({ ...config, value: e.target.value })} type="number" value={config.value ?? ''} />
      </Field>
      <Banner variant="default" description={<>Ative as conversões em Ferramentas › API oficial › Conversões.</>} />
    </div>
  );
}
